var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronLeftBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7361 26.8792C23.9011 26.6729 23.9888 26.446 23.9991 26.1985C24.0094 25.9509 23.9217 25.7343 23.7361 25.5486L18.2899 20.1024L23.767 14.6253C23.932 14.4603 24.0094 14.2385 23.9991 13.96C23.9888 13.6815 23.9011 13.4597 23.7361 13.2947C23.5298 13.0884 23.308 12.9904 23.0708 13.0007C22.8335 13.0111 22.6221 13.109 22.4364 13.2947L16.2785 19.4526C16.1754 19.5558 16.1031 19.6589 16.0619 19.7621C16.0206 19.8652 16 19.9787 16 20.1024C16 20.2262 16.0206 20.3397 16.0619 20.4428C16.1031 20.546 16.1754 20.6491 16.2785 20.7523L22.4055 26.8792C22.5911 27.0649 22.8077 27.1526 23.0553 27.1423C23.3028 27.1319 23.5298 27.0443 23.7361 26.8792Z",
    fill: "#2C74D6"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeftBlue);
export default "data:image/svg+xml,%3csvg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M23.7361 26.8792C23.9011 26.6729 23.9888 26.446 23.9991 26.1985C24.0094 25.9509 23.9217 25.7343 23.7361 25.5486L18.2899 20.1024L23.767 14.6253C23.932 14.4603 24.0094 14.2385 23.9991 13.96C23.9888 13.6815 23.9011 13.4597 23.7361 13.2947C23.5298 13.0884 23.308 12.9904 23.0708 13.0007C22.8335 13.0111 22.6221 13.109 22.4364 13.2947L16.2785 19.4526C16.1754 19.5558 16.1031 19.6589 16.0619 19.7621C16.0206 19.8652 16 19.9787 16 20.1024C16 20.2262 16.0206 20.3397 16.0619 20.4428C16.1031 20.546 16.1754 20.6491 16.2785 20.7523L22.4055 26.8792C22.5911 27.0649 22.8077 27.1526 23.0553 27.1423C23.3028 27.1319 23.5298 27.0443 23.7361 26.8792Z' fill='%232C74D6'/%3e %3c/svg%3e";
export { ForwardRef as ReactComponent };